export default __webpack_public_path__ + "static/vplab-ce5006ee444fc87473c483fee1424936.png";